import { useState } from 'react';
import downloadProfile from 'api/downloadProfile';
import { AnonymisationType } from 'types/types';
import { AllDialectOptions } from 'types/dialects';

type UseProfileDownloadProps = {
  learnerId: string;
  profileId: string;
  downloadDialect: Exclude<AllDialectOptions, 'evaluation-dialect'>;
  anonymisationType?: AnonymisationType;
  onDownloadError?: () => void;
};

export const useProfileDownload = ({
  learnerId,
  profileId,
  downloadDialect,
  anonymisationType,
  onDownloadError,
}: UseProfileDownloadProps) => {
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);

  const onDownloadProfile = async () => {
    try {
      setShowDownloadProgress(true);
      await downloadProfile(
        learnerId,
        profileId,
        downloadDialect,
        anonymisationType,
      );
    } catch {
      onDownloadError?.();
    } finally {
      setShowDownloadProgress(false);
    }
  };

  return {
    onDownloadProfile,
    showDownloadProgress,
    setShowDownloadProgress,
  };
};
